import differenceInMilliSeconds from 'date-fns/difference_in_milliseconds'

export default {
  name: 'app',

  data: function () {
    return {
      sidebarOpen: true,
      showProfile: false,
      showOverlay: true,
      showMobileMenu: false,
      showLinkText: true,
      hasErrors: true,
      isLogin: false,
      timer: null,
      linkMenuText: {},
      environment: null
    }
  },

  mounted: function () {
    this.linkMenuText = this.$stringFile['en'].menu
    this.environment = this.$environment
    // this.linkMenuText = this.$stringFile[[$store.getters.getUserHomeLanguage]].menu
  },

  created: function () {
    // Listen to $emit event
    this.$root.$on('refreshToken', () => {
      this.scheduleTimer()
    })
    this.$root.$on('logout', () => {
      this.cancelTimer()
    })
  },

  watch: {
    /**
     *
     */
    '$route.name': function () {
      this.checkLogin()
    }
  },

  methods: {
    /**
     * Call /refresh endpoint
     */
    refreshToken: function () {
      console.log('=> refreshToken: ', new Date().toString())

      this.$http.post('v1/ondusapi/oidc/webauth/refresh',
        {
          'refresh_token': this.$store.getters.getRefreshToken,
          'state_token': this.$store.getters.getStateToken
        },
        {
          credentials: 'include'
        }
      )
        .then(res => {
          console.log('POST /oidc/refresh', res)

          if (res && res.body &&
            res.body.access_token &&
            res.body.refresh_token &&
            res.body.expires_in &&
            res.body.state_token) {
            // Store token data:
            this.$storeOAuth(res.body)
            // Set refresh timer
            this.scheduleTimer()
          } else {
            console.log('Error: token not found on res.body')
            this.$store.commit('setStateToken', null)
            this.$store.commit('setAccessToken', null)
            this.$store.commit('setRefreshToken', null)
            this.$store.commit('setExpiresIn', null)
            this.cancelTimer()
          }
        })
        .catch(err => {
          console.log('Error POST oidc/refresh', err)
          this.$store.commit('setStateToken', null)
          this.$store.commit('setAccessToken', null)
          this.$store.commit('setRefreshToken', null)
          this.$store.commit('setExpiresIn', null)
          this.cancelTimer()
        })
    },

    /**
     * Reset/remove stored data
     */
    logOut: function () {
      console.log('doing logout')
      if (this.$store.getters.getRefreshToken && this.$store.getters.getStateToken) {
        // Clear IDP session on backend side
        this.$http.post('v1/ondusapi/oidc/webauth/logout',
          {
            'refresh_token': this.$store.getters.getRefreshToken,
            'state_token': this.$store.getters.getStateToken
          }, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.getters.getAccessToken
            }
          }
        )
          .then(response => {
            console.log('POST v1/ondusapi/oidc/webauth/logout', response)
            // Cancel timer on root component:
            this.$root.$emit('logout')
            // Clear user session on backend side
            this.$clearSession()
          })
          .catch(err => {
            console.log('Error logOut:', err)
            // Cancel timer on root component:
            this.$root.$emit('logout')
            // Clear Vuex store state on error
            this.$removeStoredData(false)
          })
      } else {
        // Clear Vuex store state on error
        console.log('Refresh token - State token not found.')
        this.$removeStoredData(false)
      }
    },

    /**
     * Cancel timer on destroy
     */
    cancelTimer: function () { clearInterval(this.timer) },

    /**
     * Schedule a setTimeout to refresh the token 10 minutes before it actually expires
     */
    scheduleTimer: function () {
      this.cancelTimer()
      let utcSeconds = this.$store.getters.getExpiresIn
      console.log('=> utcSeconds: ', utcSeconds)
      let d = new Date(0) // The 0 sets the date to the epoch
      d.setUTCSeconds(utcSeconds)
      const diffM = differenceInMilliSeconds(d, new Date())
      console.log('=> later: ', d)
      console.log('=> before: ', new Date())
      console.log('=> set timer: ', diffM)
      const tValRes = parseInt(diffM)
      this.timer = setInterval(this.refreshToken, tValRes)
    },

    /**
     *
     */
    sizeToggle: function () {
      this.sidebarOpen = !this.sidebarOpen
      this.showLinkText = !this.showLinkText
      this.$root.$emit('headerToggle', this.sidebarOpen)
    },

    /**
     *
     */
    openMenu: function () {
      this.showMobileMenu = !this.showMobileMenu
    },

    /**
     *
     */
    closeMenu: function () {
      // console.log('test')
      this.showMobileMenu = false
    },

    /**
     *
     */
    checkLogin: function () {
      if (this.$route.name === 'login') {
        this.isLogin = true
        this.showOverlay = true
      } else {
        this.isLogin = false
        this.showOverlay = false
      }
    }
  },

  beforeDestroy () {
    this.cancelTimer()
  },

  beforeMount: function () {
    this.checkLogin()
  }

}



// WEBPACK FOOTER //
// ./src/components/app-component/app.js